export default function WallOfFame() {
  const wallOfFamePage = document.querySelector('.lfcWallOfFame');

  if (!wallOfFamePage) return;

  let wallOfFame = wallOfFamePage.querySelector('.wall-of-fame');
  const seasonSelector = wallOfFamePage.querySelector('.wall-of_fame__filter-season-selector');
  const sectionSelectors = wallOfFamePage.querySelectorAll('.wall-of_fame__filter-section input[name="section"]');
  const discipleSelectors = wallOfFamePage.querySelectorAll('.wall-of_fame__filter-disciple input[name="disciple"]');
  const availableSections = [];
  const availableDisciples = [];

  // isIndexPage && fetchContent(seasonSelector.querySelector('option'));

  sectionSelectors.forEach(sectionSelector => {
    availableSections.push(sectionSelector.dataset.section);

    sectionSelector.addEventListener('change', function () {
      if (sectionSelector.checked) {
        wallOfFame.setAttribute('data-section', sectionSelector.dataset.section);
      }
    });
  });

  discipleSelectors.forEach(discipleSelector => {
    availableDisciples.push(discipleSelector.dataset.disciple);

    discipleSelector.addEventListener('change', function () {
      if (discipleSelector.checked) {
        wallOfFame.setAttribute('data-disciple', discipleSelector.dataset.disciple);
      }
    });
  });

  selectAvailable();

  seasonSelector.addEventListener('change', function () {
    let selectedSeason = seasonSelector.options[seasonSelector.selectedIndex];
    location.href = selectedSeason.dataset.url;
  });

  function selectAvailable() {
    const firstBlock = wallOfFame.querySelector('.wall-of-fame-block');

    if (!firstBlock) return;

    wallOfFame.dataset.section = firstBlock.dataset.section;
    wallOfFame.dataset.disciple = firstBlock.dataset.disciple;

    // fix filter selection
    for (let section of sectionSelectors) {
      if (section.dataset.section == firstBlock.dataset.section) {
        section.checked = true;
        break;
      }
    }

    // fix filter selection
    for (let section of discipleSelectors) {
      if (section.dataset.disciple == firstBlock.dataset.disciple) {
        section.checked = true;
        break;
      }
    }
  }
};
